import React, { useContext } from "react";
import Context from "../OriginStoryProvider";
import Header from "./Header";
import TopText from "./TopText";
import QuoteWithImg1 from "./QuoteWithImg1";
import DeepDive1 from "./DeepDive1";
import LargeQuote from "../Shared/LargeQuote";
import MediaAndText from "../Shared/MediaAndText";
import FullWidthImage from "../Shared/FullWidthImage";
import QuoteWithImg2 from "./QuoteWithImg2";
import DeepDive2 from "./DeepDive2";
import LargeQuoteMediaAndText from "./LargeQuoteMediaAndText";
import Paragraph from "../Shared/Paragraph";
import DeepDive3 from "./DeepDive3";
import DeepDive4 from "./DeepDive4";

const Chapter3 = () => {
	const {
		data: { content },
	} = useContext(Context);

	if (!content.chapters) return null;

	return (
		<section id="chapter-3" className="chapter-3">
			<Header />
			<TopText />
			<QuoteWithImg1 />
			<DeepDive1 />
			<LargeQuote
				elClass="chapter-3__purple-quote--1"
				quote={content.chapters.third.purple_quote_1.quote}
				source={content.chapters.third.purple_quote_1.attribution}
				imgSrc={`${mainScript.assetPath}images/svg/graphics/bg-shape--purple-circle.svg`}
			/>
			<MediaAndText
				image={`${mainScript.assetPath}images/jpg/chapter-3/james-blaisdell-cap-gown.jpg`}
				imgCaption={content.chapters.third.media_text_1.img_caption}
				imgAlt={content.chapters.third.media_text_1.img_alt}
				paragraph={content.chapters.third.media_text_1.paragraph}
				elClass="chapter-3__media-and-text--1"
			/>
			<MediaAndText
				image={`${mainScript.assetPath}images/jpg/chapter-3/jimmy-blaisdell-young.jpg`}
				imgCaption={content.chapters.third.media_text_2.img_caption}
				imgAlt={content.chapters.third.media_text_2.img_alt}
				paragraph={content.chapters.third.media_text_2.paragraph}
				elClass="chapter-3__media-and-text--2"
			/>
			<FullWidthImage
				elClass="chapter-3__full-width-img--1"
				imgCaption={content.chapters.third.full_width_img_1.img_caption}
				imgSrc={`${mainScript.assetPath}images/jpg/chapter-3/pomona-pres-house-barbara-blaisdell.jpg`}
				imgAlt={content.chapters.third.full_width_img_1.img_alt}
			/>
			<QuoteWithImg2 />
			<DeepDive2 />
			<LargeQuoteMediaAndText
				elClass={"chapter-3__large-quote-and-media-text-1"}
				quote={content.chapters.third.large_quote_media_text_1.quote}
				source={content.chapters.third.large_quote_media_text_1.attribution}
				imgCaption={content.chapters.third.large_quote_media_text_1.img_caption}
				imgSrc={`${mainScript.assetPath}images/jpg/chapter-3/scripps-seated-book-v1.jpg`}
				imgShape={`${mainScript.assetPath}images/svg/graphics/shape-bg--yellow-shield.svg`}
				imgAlt={content.chapters.third.large_quote_media_text_1.img_alt}
				textComponent={<DeepDive3 />}
			/>
			<LargeQuote
				elClass="chapter-3__purple-quote--2"
				quote={content.chapters.third.purple_quote_2.quote}
				source={content.chapters.third.purple_quote_2.attribution}
				imgSrc={`${mainScript.assetPath}images/svg/graphics/bg-shape--purple-circle.svg`}
			/>
			<LargeQuoteMediaAndText
				elClass={"chapter-3__large-quote-and-media-text-2"}
				bgImg={`${mainScript.assetPath}images/jpg/chapter-3/scripps-betty-lyell-hilda-gardner.jpg`}
				quote={content.chapters.third.large_quote_media_text_2.quote}
				source={content.chapters.third.large_quote_media_text_2.attribution}
				imgCaption={content.chapters.third.large_quote_media_text_2.img_caption}
				imgSrc={`${mainScript.assetPath}images/jpg/chapter-3/scripps-betty-lyell-hilda-gardner.jpg`}
				imgAlt={content.chapters.third.large_quote_media_text_2.img_alt}
				textComponent={
					<div
						className="chapter-3__large-quote-and-media-text-2__media-text__deep-dive__text-container"
						dangerouslySetInnerHTML={{
							__html:
								content.chapters.third.large_quote_media_text_2.paragraphs,
						}}
					/>
				}
			/>
			<LargeQuoteMediaAndText
				elClass={"chapter-3__large-quote-and-media-text-3"}
				quote={content.chapters.third.large_quote_media_text_3.quote}
				source={content.chapters.third.large_quote_media_text_3.attribution}
				imgCaption={content.chapters.third.large_quote_media_text_3.img_caption}
				imgSrc={`${mainScript.assetPath}images/jpg/chapter-3/edith-parker-room-sumner-hall-crop-v1.jpg`}
				imgAlt={content.chapters.third.large_quote_media_text_3.img_alt}
				textComponent={<DeepDive4 />}
			/>
			<FullWidthImage
				elClass="chapter-3__full-width-img--2"
				imgCaption={content.chapters.third.full_width_img_2.img_caption}
				imgSrc={`${mainScript.assetPath}images/jpg/chapter-3/harwood-court-1940-v1.jpg`}
				imgAlt={content.chapters.third.full_width_img_2.img_alt}
				imgWidth="2880"
				imgHeight="2040"
			/>
			<Paragraph
				elClass="chapter-3__paragraph--1"
				text={content.chapters.third.paragraph_1.text}
			/>
			<LargeQuote
				elClass="chapter-3__purple-quote--3"
				quote={content.chapters.third.purple_quote_3.quote}
				source={content.chapters.third.purple_quote_3.attribution}
				imgSrc={`${mainScript.assetPath}images/svg/graphics/shape-bg--shield.svg`}
			/>
		</section>
	);
};

export default Chapter3;
